<template>
  <div class="space-y-6">
    <!-- Export Status Selection -->
    <div>
      <label class="block text-sm font-medium text-gray-700 mb-3">
        Export Status
      </label>
      <div class="space-y-3">
        <label class="flex items-start">
          <input
            v-model="localStatus"
            type="radio"
            value="gbp_updated"
            class="mt-1 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
            @change="updateStatus">
          <div class="ml-3">
            <span class="block text-sm font-medium text-gray-700">
              GBP Updated
            </span>
            <span class="block text-sm text-gray-500">
              We have updated your Google Business Profile with the following optimizations.
              These changes will help improve your local search visibility and customer engagement.
            </span>
          </div>
        </label>

        <label class="flex items-start">
          <input
            v-model="localStatus"
            type="radio"
            value="email_only"
            class="mt-1 focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
            @change="updateStatus">
          <div class="ml-3">
            <span class="block text-sm font-medium text-gray-700">
              Email Only
            </span>
            <span class="block text-sm text-gray-500">
              Please review the following recommendations for your Google Business Profile.
              Implementing these suggestions will help optimize your local presence and attract more customers.
            </span>
          </div>
        </label>
      </div>
    </div>

    <!-- Export Button -->
    <div class="flex justify-center">
      <button
        type="button"
        class="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md
          shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2
          focus:ring-offset-2 focus:ring-indigo-500"
        @click="$emit('export')">
        <i class="fas fa-file-pdf mr-2" />
        Export to PDF
      </button>
    </div>

    <!-- Help Text -->
    <div class="rounded-md bg-gray-50 p-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <i class="fas fa-info-circle text-gray-400" />
        </div>
        <div class="ml-3">
          <p class="text-sm text-gray-700">
            The PDF will include all checklist information, recommendations, services, and Q&As.
            Make sure to save the checklist before exporting.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  modelValue: {
    type: String,
    default: 'email_only'
  },
  checklistId: {
    type: String,
    default: null
  }
})

const emit = defineEmits(['update:modelValue', 'export'])

const localStatus = ref(props.modelValue)

const updateStatus = () => {
  emit('update:modelValue', localStatus.value)
}

watch(() => props.modelValue, (newValue) => {
  localStatus.value = newValue
})
</script>
